import { memo } from "react";
import { Avatar, ListItem, ListItemIcon, Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { styled } from "@mui/material/styles";

import { useCustomer } from "../../AuthProvider";
import { CustomAutocomplete } from "../../components/Inputs/CustomAutocomplete";
import { navIconStyles } from "./NavIcon";

const CustomerAvatar = styled(Avatar)(({ theme }) => ({
  fontSize: "0.80rem",
  fontWeight: "bold",
  backgroundColor: "transparent",
  color: theme.vars.palette.menu.text,
  justifyContent: "unset",
  width: "30px",
  height: "30px",
}));

const useStyles = makeStyles()((theme) => ({
  customerImpersonate: {
    height: "auto",
    "& .MuiInputBase-root": {
      marginTop: 0,
    },
    "& .MuiInputBase-input": {
      color: theme.vars.palette.menu.text,
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "transparent",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled, .Mui-error):before": {
      borderBottomColor: theme.vars.palette.menu.text,
      borderBottomWidth: "1px",
    },
  },
}));

const CustomerDropdown = memo(
  ({ open, popoverMinWidth }: { open: boolean; popoverMinWidth?: number }) => {
    const {
      selectedCustomer,
      customerOptions,
      customerTrigramDict,
      anonymizedSelectedCustomer,
      showDropdown,
      handleCustomerChange,
    } = useCustomer();
    const { classes: navClasses } = navIconStyles();
    const { classes } = useStyles();

    if (!showDropdown) return null;

    return (
      <ListItem
        disablePadding
        className={`${navClasses.menuItem} ${classes.customerImpersonate}`}
      >
        <Box
          sx={[
            {
              p: "0 8px 0 18px",
              display: "flex",
              alignItems: "center",
            },
          ]}
        >
          <ListItemIcon
            sx={[
              { minWidth: 0, justifyContent: "center" },
              open ? { mr: 1.5 } : { mr: 0 },
            ]}
          >
            <CustomerAvatar>
              {selectedCustomer && anonymizedSelectedCustomer
                ? customerTrigramDict[anonymizedSelectedCustomer] ||
                  anonymizedSelectedCustomer.slice(0, 3).toUpperCase()
                : ""}
            </CustomerAvatar>
          </ListItemIcon>
          <CustomAutocomplete
            disableClearable
            formStyle={false}
            variant="standard"
            options={customerOptions}
            sx={[
              { "& .MuiFormControl-root": { margin: 0 } },
              open
                ? { width: "100%" }
                : { visibility: "hidden", overflow: "hidden" },
            ]}
            value={anonymizedSelectedCustomer ?? undefined}
            onChange={(_, value) => handleCustomerChange(value ?? "")}
            {...(popoverMinWidth !== undefined && {
              slotProps: {
                paper: { sx: { minWidth: popoverMinWidth } },
              },
            })}
          />
        </Box>
      </ListItem>
    );
  }
);

export default CustomerDropdown;
